module.exports = __webpack_public_path__ + "static/scale-model-of-minneapolis-sculpture-garden-in-minneapolis-minnesota-a9f498a278cc4dbea7730681fbb3d2d2.png";